var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2218_3086",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.8934,
    height: 20.8935,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2218_3086)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19768 0.345629C1.80715 -0.0448975 1.17399 -0.0448968 0.783468 0.345629L0.345626 0.783475C-0.0448964 1.174 -0.0448961 1.80717 0.345626 2.1977L8.59487 10.447L0.345807 18.6962C-0.0447158 19.0867 -0.0447163 19.7199 0.345806 20.1104L0.783649 20.5482C1.17417 20.9388 1.80733 20.9388 2.19786 20.5482L10.4469 12.2991L18.6958 20.548C19.0863 20.9386 19.7195 20.9386 20.11 20.548L20.5478 20.1102C20.9384 19.7197 20.9384 19.0865 20.5478 18.696L12.299 10.447L20.548 2.19788C20.9386 1.80735 20.9386 1.17419 20.548 0.78366L20.1102 0.345813C19.7197 -0.0447134 19.0865 -0.0447131 18.696 0.345813L10.4469 8.59495L2.19768 0.345629Z",
    fill: "#0CADED"
  }))));
};
export default SvgClose;